import React, { useEffect, useState } from 'react';
import { heroSlides } from '../mock';
import { ArrowRight } from 'lucide-react';

export default function HeroSlider() {
  const [i, setI] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setI((v) => (v + 1) % heroSlides.length), 7000);
    return () => clearInterval(t);
  }, []);

  return (
    <section id="home" className="relative min-h-[100svh] md:min-h-[720px] h-[100svh] md:h-[100vh] w-full overflow-hidden bg-[#0e1421]">
      {heroSlides.map((s, idx) => (
        <div
          key={s.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            idx === i ? 'opacity-100' : 'opacity-0 pointer-events-none'
          }`}
        >
          <img
            src={s.image}
            alt={s.title}
            className={`w-full h-full object-cover ${idx === i ? 'jh-kenburns' : ''}`}
            style={{ objectPosition: 'right center' }}
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0e1421] via-[#0e1421]/85 to-[#0e1421]/20" />

          {/* Red decorative circles */}
          <div className="absolute -left-40 top-1/3 w-[420px] h-[420px] rounded-full bg-[#E11D2E]/80 blur-[2px] hidden md:block" />
          <div className="absolute -right-56 bottom-0 w-[520px] h-[520px] rounded-full bg-[#E11D2E]/90 hidden md:block" />

          {/* Concentric ring accent */}
          <div className="absolute right-24 top-24 w-[520px] h-[520px] rounded-full border border-white/15 hidden lg:block" />
          <div className="absolute right-40 top-40 w-[380px] h-[380px] rounded-full border border-white/10 hidden lg:block" />

          <div className="absolute inset-0 z-10 pt-[88px] md:pt-0">
            <div className="h-full max-w-[1400px] mx-auto px-6 lg:px-10 flex flex-col justify-center">
              {idx === i && (
                <div className="jh-fade-in-up max-w-4xl xl:max-w-5xl">
                  <p className="text-white/90 tracking-[0.16em] md:tracking-[0.18em] text-[11px] md:text-sm font-semibold uppercase mb-4 md:mb-6">
                    {s.eyebrow}
                  </p>
                  <h1 className="jh-h1 text-white mb-2 md:mb-3">{s.title}</h1>
                  <h1 className="jh-h1 text-white mb-8 md:mb-10">{s.titleAccent}</h1>
                  <a href="#contact" className="jh-btn-primary">
                    <span>{s.cta}</span>
                    <ArrowRight size={18} />
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      ))}

      {/* Slide indicators */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-20 flex items-center gap-3">
        {heroSlides.map((_, idx) => (
          <button
            key={idx}
            aria-label={`Slide ${idx + 1}`}
            onClick={() => setI(idx)}
            className={`h-[3px] transition-all duration-300 ${
              idx === i ? 'w-14 bg-[#E11D2E]' : 'w-8 bg-white/40 hover:bg-white/70'
            }`}
          />
        ))}
      </div>

      {/* Bottom eyebrow marker (matches the small red dot at top of nav in original) */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 z-20">
        <div className="w-3 h-3 rounded-full bg-[#E11D2E] translate-y-[-6px]" />
      </div>
    </section>
  );
}
